<p-drawer
  [visible]="mobileNav.visible()"
  (visibleChange)="onDrawerVisibleChange($event)"
  [position]="drawerPosition()"
  [modal]="true"
  [dismissible]="true"
  [blockScroll]="false"
  [closable]="true"
>
  <ng-template #headless>
    <nav
      class="flex h-full min-w-0 max-w-full flex-col bg-white"
      [attr.aria-label]="config().ariaLabel ?? 'Mobile navigation'"
    >
      <div class="flex min-w-0 items-center justify-between gap-3 border-b border-ssrk-border px-5 py-4">
        <p class="min-w-0 break-words font-serif text-lg font-bold text-ssrk-blue-primary">
          {{ config().title ?? 'Menu' }}
        </p>
        <button
          type="button"
          class="flex h-11 w-11 items-center justify-center rounded-full bg-ssrk-bg text-xl text-ssrk-text-heading"
          aria-label="Close menu"
          (click)="closeNav()"
        >
          ✕
        </button>
      </div>

      <div class="min-w-0 flex-1 overflow-y-auto px-5 pb-8 pt-2">
        @for (item of visibleItems(); track $index) {
          @if (item.type === 'link') {
            <div class="border-b border-ssrk-border">
              @if (item.routerLink) {
                <a
                  [routerLink]="item.routerLink"
                  routerLinkActive="text-ssrk-blue-primary"
                  [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
                  class="flex min-w-0 items-center justify-between gap-3 break-words py-4 text-base font-semibold text-ssrk-text-heading"
                  (click)="onNavLinkClick($event, { routerLink: item.routerLink })"
                >
                  {{ item.label }}
                </a>
              } @else {
                <a
                  [href]="item.href ?? '#'"
                  class="flex min-w-0 items-center justify-between gap-3 break-words py-4 text-base font-semibold text-ssrk-text-heading"
                  (click)="onNavLinkClick($event, { href: item.href })"
                >
                  {{ item.label }}
                </a>
              }
            </div>
          } @else {
            <div class="border-b border-ssrk-border">
              <button
                type="button"
                class="flex w-full min-w-0 items-center justify-between gap-3 break-words py-4 text-left text-base font-semibold text-ssrk-text-heading"
                (click)="toggleGroup(item, $index)"
                [attr.aria-expanded]="isGroupOpen(item, $index)"
              >
                {{ item.label }}
                <span class="text-xs" [class.rotate-180]="isGroupOpen(item, $index)">▾</span>
              </button>

              @if (isGroupOpen(item, $index)) {
                <div class="pb-3 pl-4">
                  @for (child of visibleChildren(item); track child.label; let last = $last) {
                    @if (child.routerLink) {
                      <a
                        [routerLink]="child.routerLink"
                        routerLinkActive="text-ssrk-blue-primary"
                        [routerLinkActiveOptions]="{ exact: child.exact ?? false }"
                        class="block min-w-0 break-words py-2.5 text-sm text-ssrk-text-body"
                        [class.border-b]="!last"
                        [class.border-ssrk-bg]="!last"
                        (click)="onNavLinkClick($event, { routerLink: child.routerLink })"
                      >
                        {{ child.label }}
                      </a>
                    } @else {
                      <a
                        [href]="child.href ?? '#'"
                        class="block min-w-0 break-words py-2.5 text-sm text-ssrk-text-body"
                        [class.border-b]="!last"
                        [class.border-ssrk-bg]="!last"
                        (click)="onNavLinkClick($event, { href: child.href })"
                      >
                        {{ child.label }}
                      </a>
                    }
                  }
                </div>
              }
            </div>
          }
        }

        @if (config().cta && !config().cta!.hidden) {
          @if (config().cta!.fragment || config().cta!.href?.startsWith('#')) {
            <button
              type="button"
              class="mt-6 block w-full min-w-0 break-words rounded-ssrk-sm bg-ssrk-blue-primary px-4 py-3.5 text-center text-[15px] font-bold text-white"
              (click)="
                onNavLinkClick($event, {
                  routerLink: config().cta!.routerLink,
                  fragment: config().cta!.fragment,
                  href: config().cta!.href,
                })
              "
            >
              {{ config().cta!.label }}
            </button>
          } @else if (config().cta!.routerLink) {
            <a
              [routerLink]="config().cta!.routerLink"
              class="mt-6 block min-w-0 break-words rounded-ssrk-sm bg-ssrk-blue-primary px-4 py-3.5 text-center text-[15px] font-bold text-white"
              (click)="onNavLinkClick($event, { routerLink: config().cta!.routerLink })"
            >
              {{ config().cta!.label }}
            </a>
          } @else {
            <a
              [href]="config().cta!.href ?? '#'"
              class="mt-6 block min-w-0 break-words rounded-ssrk-sm bg-ssrk-blue-primary px-4 py-3.5 text-center text-[15px] font-bold text-white"
              (click)="onNavLinkClick($event, { href: config().cta!.href })"
            >
              {{ config().cta!.label }}
            </a>
          }
        }

        @if (config().contacts?.length) {
          <div class="-mx-5 mt-6 bg-ssrk-bg px-5 py-5">
            @for (contact of config().contacts; track contact.text) {
              <p
                class="flex min-w-0 items-start gap-2 break-words text-[13px] text-ssrk-text-muted"
                [class.mb-1.5]="$index < (config().contacts?.length ?? 0) - 1"
              >
                @if (contact.icon) {
                  <span aria-hidden="true">{{ contact.icon }}</span>
                }
                {{ contact.text }}
              </p>
            }
          </div>
        }

        <ng-content />
      </div>
    </nav>
  </ng-template>
</p-drawer>
